/**
 * Weekday steps for building mock fixtures (dates relative to "now" that land
 * on a weekday). Mock data only: the platform's calendar (bank holidays, our
 * shutdowns) is the backend's, and no page or domain helper counts working
 * days itself.
 */

export function isWeekend(d: Date): boolean {
  const day = d.getUTCDay();
  return day === 0 || day === 6;
}

export function addWorkingDays(from: Date, n: number): Date {
  const d = new Date(from);
  let left = n;
  while (left > 0) {
    d.setUTCDate(d.getUTCDate() + 1);
    if (!isWeekend(d)) left -= 1;
  }
  return d;
}

export function subtractWorkingDays(from: Date, n: number): Date {
  const d = new Date(from);
  let left = n;
  while (left > 0) {
    d.setUTCDate(d.getUTCDate() - 1);
    if (!isWeekend(d)) left -= 1;
  }
  return d;
}
